import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {MeasurementManagementFeature} from "../../features/measurementManagement";

const ALLOWED_PERMISSION = 'measurementManagement'

const MeasurementManagementPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <MeasurementManagementFeature
      userToken={userToken}
    />
  </PermissionGuard>
)

export default MeasurementManagementPage
